import { render, staticRenderFns } from "./areamanage.vue?vue&type=template&id=f09c8578&scoped=true&"
import script from "./areamanage.vue?vue&type=script&lang=js&"
export * from "./areamanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09c8578",
  null
  
)

export default component.exports